import { ThunkDispatch, AnyAction, Dispatch } from '@reduxjs/toolkit'
import { GenericState } from '../../redux/lib'

export type RequestErrorResponseFields = ResponseField[]

export type ResponseField = {
  field: string
  message: string
}

export type RequestErrorResponse = {
  code: ErrorType
  fields: RequestErrorResponseFields
  message: string
}

export type APIResponseErrorItem = {
  field: string
  message: string
}

export const token: string  = localStorage.getItem('wivi.access_token') || "";

export type ErrorType = 'invalid' | 'error' | 'auth'

export type AppDispatch = ThunkDispatch<
  GenericState<unknown>,
  null | undefined,
  AnyAction
> &
  Dispatch<AnyAction>

export type DisplayErrorState = {
  code: ErrorType
  message: string
  fields: ResponseField[]
}

export interface DisplayErrorProps extends DisplayErrorState {
  title?: string
}

export interface ResponseCallback<O> { (response: unknown):O }